import Cookies from "js-cookie";

export function checkCookie(name) {
  return Cookies.get(name) ? true : false;
}

export function getCookie(name) {
  return Cookies.get(name);
}
